<template>
  <v-form ref="contactUsForm" v-model="valid" lazy-validation>
    <div class="d-flex flex-wrap">
      <div class="d-flex flex-column" style="height: 100%">
        <h1 class="title">
          Ready To Build Your Website?
          <!-- <v-btn x-small fab color="primary" class="ml-4" @click="reset">
            <v-icon> mdi-close</v-icon>
          </v-btn> -->
        </h1>
        <div class="mt-5">
          <div class="d-flex flex-row" style="height: 100%">
            <v-text-field
              class="mr-5"
              :solo="solo"
              :clearable="clearable"
              :solo-inverted="soloInverted"
              :outlined="outlined"
              :color="color"
              :dense="dense"
              :filled="filled"
              :disabled="disabled"
              :rules="[rules.required]"
              :style="styles['name']"
              :class="classes['name']"
              v-model="localName"
              :label="name"
            ></v-text-field>

            <v-text-field
              :solo="solo"
              :clearable="clearable"
              :outlined="outlined"
              :solo-inverted="soloInverted"
              :color="color"
              :dense="dense"
              :filled="filled"
              :disabled="disabled"
              :rules="[rules.required]"
              :style="styles['email']"
              :class="classes['email']"
              v-model="localEmail"
              :label="email"
            ></v-text-field>
          </div>

          <v-textarea
            :solo="solo"
            :clearable="clearable"
            :outlined="outlined"
            :solo-inverted="soloInverted"
            :color="color"
            :dense="dense"
            :filled="filled"
            :disabled="disabled"
            :style="styles['message']"
            :class="classes['message']"
            v-model="localMessage"
            :label="message"
            :rules="[rules.required]"
          >
          </v-textarea>
          <v-select
            :outlined="outlined"
            :items="items"
            :solo="solo"
            :clearable="clearable"
            :solo-inverted="soloInverted"
            :color="color"
            :dense="dense"
            :filled="filled"
            :disabled="disabled"
            :style="styles['itemsSelect']"
            :class="classes['itemsSelect']"
            :rules="[rules.required]"
            :label="itemsToSelect"
            v-model="selectedItem"
          ></v-select>
          <v-checkbox
            v-model="checkbox"
            :rules="[rules.required]"
            label="Do you agree?"
            required
          ></v-checkbox>
          <v-spacer></v-spacer>
          <v-btn class="float-right" fab small color="primary" @click="submit">
            <v-icon> mdi-email-send</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-snackbar v-model="snackbar">{{ snackbarText }}</v-snackbar>
  </v-form>
</template>
<script>
import formValidable from "../../mixins/formValidable";
import emittable from "../../mixins/emittable";

import {
  VForm,
  VTextField,
  VTextarea,
  VSelect,
  VCheckbox,
  VSpacer,
  VBtn,
  VIcon,
  VSnackbar
} from "vuetify/lib"

export default {
  mixins: [formValidable, emittable],
  components: {
    VForm,
    VTextField,
    VTextarea,
    VSelect,
    VCheckbox,
    VSpacer,
    VBtn,
    VIcon,
    VSnackbar
  },
  props: {
    bus: {
      type: Object,
      default: undefined,
    },
    name: {
      type: String,
      default: "Name",
    },
    email: {
      type: String,
      default: "Email",
    },
    message: {
      type: String,
      default: "Tell us about your project...",
    },
    itemsToSelect: {
      type: String,
      default: "Select your solution ",
    },
    color: {
      type: String,
      default: "primary",
    },
    solo: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    soloInverted: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledWhenNotValid: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: function () {
        return ["Item 1", "Item 2", "Item 3", "Item 4"];
      },
    },
    styles: {
      type: Object,
      default: function () {
        return {
          name: {},
          email: {},
          message: {},
        };
      },
    },
    classes: {
      type: Object,
      default: function () {
        return {
          name: {},
          email: {},
          message: {},
        };
      },
    },
  },
  mounted() {
    if (this.bus) {
      this.bus.on("reset-validation", function () {
        this.$refs.contactUsForm.resetValidation();
      });

      this.bus.on("reset", function () {
        this.$refs.contactUsForm.reset();
      });
    }
  },
  data: () => ({
    valid: undefined,
    localName: "",
    localEmail: "",
    localMessage: "",
    selectedItem: "",
    checkbox: false,
    snackbarText: "",
    snackbar: false,
  }),

  methods: {
    submit() {
      this.emit("submit-form");
      this.reset();
      var message = "Your message has been sent. Yuo will soon have an answer";
      this.handleSnackBar(message);
    },
    reset() {
      this.localName = undefined;
      this.localEmail = undefined;
      this.localMessage = undefined;
      this.selectedItem = undefined;
    },
    handleSnackBar(text) {
      this.snackbarText = text;
      this.snackbar = true;
    },
  },
  watch: {
    name: function (newVal) {
      this.localName = newVal;
    },
    email: function (newVal) {
      this.localEmail = newVal;
    },
    message: function (newVal) {
      this.localMessage = newVal;
    },
  },
};
</script>
<style>
.title {
  text-align: center;
}
</style>